// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";  // ✅ 新增

const firebaseConfig = {
  apiKey: "AIzaSyALSkHgKSrdgR_L-l4KAfoSD7ChH2jrX10",
  authDomain: "nova-ai-49fcf.firebaseapp.com",
  projectId: "nova-ai-49fcf",
  storageBucket: "nova-ai-49fcf.firebasestorage.app",
  messagingSenderId: "783310968464",
  appId: "1:783310968464:web:2be06beb3323107219ea15",
  measurementId: "G-L93PMVLVBJ",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);   // ✅ 新增：导出 Firestore 实例
